import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';

// TODO: Instead of this a file upload library should be used
@Directive({
    standalone: false,
    selector: '[appDndDocument]'
})
export class DndDocumentDirective {
    private importedFiles: Array<any> = [];

    @Input() dragoverClasses: string;

    @Input() set files(value: any) {
        this.importedFiles = value;
    }

    @Output() fileDropped = new EventEmitter<any>();

    @HostListener('dragover', ['$event']) onDragOver(evt): void {
        this.dragoverClasses.split(' ').forEach((clazz) => this.renderer.addClass(this.element.nativeElement, clazz));

        if (!this.isFileDropped) {
            evt.preventDefault();
            evt.stopPropagation();
        }
    }

    @HostListener('dragleave', ['$event']) public onDragLeave(evt): void {
        this.dragoverClasses.split(' ').forEach((clazz) => this.renderer.removeClass(this.element.nativeElement, clazz));

        if (!this.isFileDropped) {
            evt.preventDefault();
            evt.stopPropagation();
        }
    }

    @HostListener('drop', ['$event']) public ondrop(evt): void {
        this.dragoverClasses.split(' ').forEach((clazz) => this.renderer.removeClass(this.element.nativeElement, clazz));

        if (!this.isFileDropped) {
            evt.preventDefault();
            evt.stopPropagation();
            const files = evt.dataTransfer.files;
            this.fileDropped.emit(files);
        }
    }

    private get isFileDropped(): boolean {
        return this.importedFiles.length > 0;
    }

    constructor(
        private element: ElementRef,
        private renderer: Renderer2
    ) {}
}
